import React from 'react'
import { useDispatch } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { storeEasyAccessToken } from 'apps/detention-review/utils/actions/accessToken'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { RouteNotFound } from 'components/404'
import { DetentionNew } from './DetentionNew'
import { DetentionReview } from './DetentionReview'
import { ExpiredPage } from './ExpiredPage'
import { SuccessPage } from './SuccessPage'

export const appName = 'detention-review'

export const App = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { userDetails } = useUserDetails()
  const hasUser = userDetails?.id
  const easyAccessToken = queryString.parse(location.search).easy_access_token
  if (easyAccessToken && typeof easyAccessToken === 'string' && !hasUser) {
    dispatch(storeEasyAccessToken(easyAccessToken))
  }
  return (
    <AppWrap appName={appName} title='Detention Review'>
      <Switch>
        <Route exact path='/' component={DetentionReview} />
        <Route exact path='/edit/:shipmentId/:accessorialId' component={DetentionReview} />
        <Route exact path='/new/:shipmentId' component={DetentionNew} />
        <Route exact path='/success/:shipmentId' component={SuccessPage} />
        <Route exact path='/expired' component={ExpiredPage} />
        <Route component={RouteNotFound} />
      </Switch>
    </AppWrap>
  )
}
